/*
 * @Author: your name
 * @Date: 2021-01-21 14:29:20
 * @LastEditTime: 2021-06-03 13:42:53
 * @LastEditors: yang chenglin
 * @Description: 营销活动数
 * @FilePath: \CJYX_DouYin\src\pages\Home\DY_components\DYMarketingNum\index.tsx
 */
import React, { useEffect, useState } from 'react';
import { Balloon, Loading, Progress } from '@alifd/next';
import styles from './index.module.scss';
import { Servlets } from '@/service';
import { history } from 'ice';
import { store } from '@ice/stark-data';
import moment from 'moment';

const activityTitle = ['本月创建活动总数：', '本月营销总人次：', '本月平均ROI：'];

const DYMarketingNum = ({ type, startTime, endTime }) => {
  const { Tooltip } = Balloon;
  const [loadingVisible, setLoadingVisible] = useState(true);
  const [trendData, setTrendData] = useState({});
  const [roi, setRoi] = useState();
  const textRender = (num) => {
    return (<div>
      <div style={{ fontSize: '14px', color: '#333333', fontWeight: 'bold' }}>{num}</div>
    </div>);
  };
  useEffect(() => {
    Servlets('getSmsCalendarSummary', {
      startTime: moment().startOf('month').valueOf(),
      endTime: moment().endOf('month').valueOf(),
    }).then((res) => {
      setTrendData(res.data);
      setLoadingVisible(false);
    });
    Servlets('getRoi', {
      startTime: moment().startOf('month').valueOf(),
      endTime: moment().endOf('month').valueOf(),
    }).then((res) => {
      setRoi(res.data);
    });
  }, [startTime, endTime, type]);
  return (
    <div className={`${styles.pageBox} DY-marketing-num`}>
      <Loading visible={loadingVisible}>
        <div className={styles.boxTitle}>营销活动数（本月）</div>
        <div className={styles.boxSize}>
          <div className={styles.fs14}>本月创建活动总数：</div>
          <div className={styles.boxRight}>{trendData?.taskNum}</div>
        </div>
        <div className={styles.boxSize}>
          <div className={styles.fs14}>本月营销总人次：</div>
          <div className={styles.boxRight}>{trendData?.peopleNum}</div>
        </div>
        <div className={styles.boxSize}>
          <div className={styles.fs14}>本月平均ROI：<Tooltip
            align="t"
            trigger={<span
              style={{ fontSize: '14px', marginLeft: '4px', cursor: 'pointer' }}
              className={'iconfont icon-icon4-33'}
            />}
          >
            ROI=实际发送人群付款总金额/（实际发送短信条数*每条短信成本）
          </Tooltip>
          </div>
          <div className={styles.boxRight}>{roi}</div>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginTop: '30px',
        }}
        >
          <div>
            <Progress
              percent={(trendData?.notExecution / trendData?.taskNum) * 100}
              shape="circle"
              size="small"
              textRender={() => textRender(trendData?.notExecution)}
            />
            <div style={{ textAlign: 'center', marginTop: '15px' }}>未开始</div>
          </div>
          <div>
            <Progress
              percent={(trendData?.execution / trendData?.taskNum) * 100}
              shape="circle"
              size="small"
              textRender={() => textRender(trendData?.execution)}
            />
            <div style={{ textAlign: 'center', marginTop: '15px' }}>投放中</div>
          </div>
          <div>
            <Progress
              percent={(trendData?.executionSuccess / trendData?.taskNum) * 100}
              shape="circle"
              size="small"
              textRender={() => textRender(trendData?.executionSuccess)}
            />
            <div style={{ textAlign: 'center', marginTop: '15px' }}>投放成功</div>
          </div>
          <div>
            <Progress
              percent={(trendData?.manualStop / trendData?.taskNum) * 100}
              shape="circle"
              size="small"
              textRender={() => textRender(trendData?.manualStop)}
            />
            <div style={{ textAlign: 'center', marginTop: '15px', marginBottom: '25px' }}>投放终止</div>
            <div
              className={`${styles.globalLink} ${styles.mt10}`}
              onClick={() => {
                history.push('/orderSelection'), { from: 'crowdMarketing' };
              }}
            >去人群营销 {'>'}
            </div>
          </div>
          <div>
            <Progress
              percent={(trendData?.executionFailed / trendData?.taskNum * 100)}
              shape="circle"
              size="small"
              textRender={() => textRender(trendData?.executionFailed)}
            />
            <div style={{ textAlign: 'center', marginTop: '15px', marginBottom: '25px' }}>投放失败</div>
            <div
              className={`${styles.globalLink} ${styles.mt10}`}
              onClick={() => {
                store.set('currentTab', 'orderSelection');
                store.set('currentTab_child', 'childTabs_orderSelect');
                history.push('/orderSelection');
                history.push('/orderSelection');
              }}
            >去订单筛选营销 {'>'}
            </div>
          </div>
        </div>
      </Loading>
    </div>
  );
};

export default DYMarketingNum;
